import React from 'react'
import MapSingleMarker from 'components/atoms/MapSingleMarker'
import styled from 'styled-components'
import { Wrapper } from 'sputnik-ui'
import { Typography } from '@material-ui/core'
import { useTranslation } from 'react-i18next'

const StyledWrapper = styled(Wrapper)`
  padding: 0;
  height: 300px;
  overflow: hidden;
  border-radius: 20px;
  position: relative;
`

// Address-pin map for the v2 install flow: unlike GateForm, the pin is
// draggable as soon as we have coordinates (no manual "touch to continue"
// step), since coordinates here can come from search, manual geocoding, or
// a previous drag.
export default function AddressMap({ lat, lon, onMove }) {
  const { t } = useTranslation(['devices'])
  const initialMarker = { lat, lon }

  return (
    <>
      <Typography gutterBottom>
        {t('devices:install_v2.set_location')}
      </Typography>
      <StyledWrapper border={false}>
        {lat && lon ? (
          <MapSingleMarker
            initialMarker={initialMarker}
            onUpdate={(marker) => {
              if (marker.lat) {
                onMove(marker.lat, marker.lon)
              }
            }}
          />
        ) : (
          <Typography
            variant="h5"
            color="textSecondary"
            style={{ margin: 'auto' }}
          >
            {t('devices:gate.choose_address')}
          </Typography>
        )}
      </StyledWrapper>
    </>
  )
}
